module.exports = function() {
  return new Worker("/" + "stylus-transpiler.eb90a03f.worker.js");
};